// client/src/components/Home.js
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";

function Home() {
  const [horoscopes, setHoroscopes] = useState({});

  // Compute admin visibility inside component
  const isAdmin = useMemo(() => {
    const token = localStorage.getItem("token");
    let storedUser = null;
    try {
      storedUser = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      storedUser = null;
    }

    const adminEmail = (process.env.REACT_APP_ADMIN_EMAIL || "").toLowerCase();
    const userEmail = (storedUser?.email || "").toLowerCase();

    return !!token && !!adminEmail && userEmail === adminEmail;
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/api/horoscope/daily`)
      .then((res) => setHoroscopes(res.data))
      .catch((err) => console.error("Failed to load horoscopes:", err));
  }, []);

  const zodiacOrder = [
    "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo",
    "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces",
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-indigo-900 to-purple-950 text-white font-sans">
      {/* Hero Section */}
      <div className="text-center py-20 px-4">
        <h1 className="text-5xl font-bold mb-4">Mysticmegabyte</h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto">
          Not your average horoscope site. Mysticmegabyte combines real astrology with cutting-edge AI to deliver the most accurate readings available online.
        </p>

        <div className="mt-6 space-x-4">
          <a
            href="/signup"
            className="bg-purple-700 hover:bg-purple-800 text-white font-semibold py-2 px-4 rounded-xl"
          >
            Get Started
          </a>

          <a
            href="/login"
            className="border border-white py-2 px-4 rounded-xl hover:bg-white hover:text-purple-900 font-semibold"
          >
            Login
          </a>

          {isAdmin && (
            <a
              href="/admin"
              className="border border-purple-300 py-2 px-4 rounded-xl hover:bg-purple-200 hover:text-black font-semibold"
            >
              Admin
            </a>
          )}
        </div>
      </div>

      {/* Horoscope Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-6 pb-16">
        {zodiacOrder.map((sign) => (
          <div
            key={sign}
            className="bg-white bg-opacity-10 backdrop-blur p-4 rounded-2xl border border-purple-600 shadow-lg"
          >
            <h2 className="text-2xl font-semibold mb-2">{sign}</h2>
            <p className="text-sm text-purple-200">{horoscopes[sign] || "Loading..."}</p>
          </div>
        ))}
      </div>

      {/* Pricing Teaser */}
      <div className="bg-purple-900 text-center py-12">
        <h2 className="text-3xl font-bold mb-4">Upgrade Your Cosmic Experience</h2>
        <p className="mb-6">
          Access personalised readings, weekly insights, and real-time transit alerts with our subscription plans.
        </p>
        <div className="space-x-4">
          <a
            href="/signup"
            className="bg-white text-purple-900 font-semibold py-2 px-4 rounded-xl"
          >
            Subscribe
          </a>
          <a
            href="/dashboard"
            className="border border-white py-2 px-4 rounded-xl hover:bg-white hover:text-purple-900 font-semibold"
          >
            View Dashboard
          </a>
        </div>
      </div>

      {/* Why We're Different */}
      <div className="bg-black py-16 px-6 text-center">
        <h2 className="text-2xl font-bold mb-4">Why Mysticmegabyte?</h2>
        <ul className="max-w-2xl mx-auto space-y-3 text-purple-200 text-left">
          <li>✨ Real-time planetary positions and transits</li>
          <li>🧠 AI that interprets astrology, not simulates it</li>
          <li>🔒 Secure accounts and highly personalised charts</li>
          <li>📬 Daily, weekly, and alert-based notifications for important astrological events just for you</li>
        </ul>
      </div>
    </div>
  );
}

export default Home;
